import React, { Component } from 'react';

import Button, { LoadingButton } from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { ModalBody, ModalFooter, ModalHeader } from '@qality/common-components';
import { messages } from '@qality/common-messages';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onDelete: () => void;
};

type State = {
  deleting: boolean;
};

export default class DeleteTestCaseFromCycleDialog extends Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false,
    };
  }

  cancel = () => {
    this.props.onCancel();
  };

  delete = async () => {
    this.setState({
      deleting: true,
    });
    await this.props.onDelete();
    this.setState({
      deleting: false,
    });
  };

  render() {
    return (
      <ModalTransition>
        {this.props.isOpen && (
          <Modal
            onClose={this.cancel}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEscapePress={true}
            shouldScrollInViewport
          >
            <ModalHeader title='Remove Test Case' appearance='danger' />
            <ModalBody>
              Are you sure that you want to remove this test case from this test
              cycle?
            </ModalBody>
            <ModalFooter>
              <Button appearance='subtle' onClick={this.cancel}>
                Cancel
              </Button>
              <LoadingButton
                isLoading={this.state.deleting}
                appearance='danger'
                onClick={this.delete}
                autoFocus
              >
                {messages['testCase.actions.remove.buttonLabel']}
              </LoadingButton>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    );
  }
}
